module.exports = __webpack_public_path__ + "img/lex-libris-logo.616e677c.svg";